import { MigrationType } from "./Statistics/MigrationType";

/** What triggered a file-priority recalculation. Matches the server RecalculationTrigger enum (camelCase). */
export enum RecalculationTrigger {
  ManualUi = "manualUi",
  SqlScriptFollowup = "sqlScriptFollowup",
  Api = "api",
}

/** Where a requested queue refresh is. Matches the server QueueRefreshState enum (camelCase). */
export enum QueueRefreshState {
  None = "none",
  Waiting = "waiting",
  Running = "running",
  Retrying = "retrying",
  Failed = "failed",
}

/** Live migration-queue lock status for a single migration type. */
export interface MigrationQueueStatus {
  migrationType: MigrationType;
  isRunning: boolean;
  /** Timestamp of the last lock heartbeat (ISO string), or null when idle. */
  lockedAt: string | null;
  /** Where a requested refresh is; it can be queued or failed while the lock shows Idle. */
  refreshState?: QueueRefreshState;
}

/** A single organization × migration type enqueue outcome. */
export interface RecalculationEnqueueOutcome {
  organizationId: string;
  migrationType: MigrationType;
  success: boolean;
  error: string | null;
}

/** Response body of POST /api/Organizations/RecalculateFilesPriorities. */
export interface RecalculateFilesPrioritiesResult {
  message: string;
  success: boolean;
  failures: RecalculationEnqueueOutcome[];
}
